import api from "app/lib/api";
import endpoints from "static/endpoints";
import { interpolate } from "utils/string";

export const getAlertProtocols = async ({ account, deviceType } = {}) => {
  if (!account?.trim() || !deviceType?.trim()) return;

  const params = new URLSearchParams({
    ...(account && { account }),
    ...(deviceType && { deviceType: encodeURIComponent(deviceType) }),
  });

  const url = `${endpoints.alertProtocol.list}?${params.toString()}`;

  const { data } = await api.get(url);
  return data;
};

export const createAlertProtocol = async (payload) => {
  return await api.post(endpoints.alertProtocol.create, payload);
};

export const updateAlertProtocol = async (payload) => {
  if (!payload?.id) return;
  const { id, ...rest } = payload;

  const url = interpolate(endpoints.alertProtocol.update, {
    protocolId: id,
  });

  return await api.put(url, rest);
};

export const deleteAlertProtocol = async (protocolId) => {
  if (!protocolId) return;

  const url = interpolate(endpoints.alertProtocol.delete, {
    protocolId,
  });

  return await api.delete(url);
};
